import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";

import { useDocumentModal } from "../DocumentModal/DocumentModalContext";
import NotesSectionDashboard from "../NotesSectionDashboard/main";
import { getCaseId, getClientId } from "../../Utils/helper";
import { api_without_cancellation } from "../../api/api";

import CostManagementModal from "./CostManagementModal";
import CostTabs from "./CostTabs";
import { useUpdateTrigger } from "./TriggerUpdateContext";

const fetchCostData = async (clientId, caseId) => {
  const { data } = await api_without_cancellation.get(`/api/costs/${clientId}/${caseId}/`);
  return data;
};

const CostDashboard = ({ pageObject }) => {
  const currentCase = useSelector((state) => state?.caseData?.current);
  const client = useSelector((state) => state?.client?.current);
  const { triggerUpdate } = useUpdateTrigger();
  const { toggleVar } = useDocumentModal();

  const [costTotalSummary, setCostTotalSummary] = useState({
    totalCreditCard: 0,
    paid: 0,
    openNotRequested: 0,
    requested: 0,
    totalAmount: 0,
  });

  const [costs, setCosts] = useState([]);
  const [envelopeCost, setEnvelopeCost] = useState({});
  const [requestedCosts, setRequestedCosts] = useState([]);
  const [creditCardCosts, setCreditCardCosts] = useState([]);
  const [openCosts, setOpenCosts] = useState([]);
  const [paidCosts, setPaidCosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [slotDetails, setSlotDetails] = useState({});

  // Function to update total amount when envelope cost changes
  const updateTotalAmount = useCallback(
    (updatedEnvelopeCost) => {
      setEnvelopeCost(updatedEnvelopeCost); // Update envelope cost state
      setCostTotalSummary((prevState) => ({
        ...prevState,
        totalAmount:
          parseFloat(prevState.totalAmount) -
          parseFloat(envelopeCost.amount || 0) +
          parseFloat(updatedEnvelopeCost.amount || 0),
      }));
    },
    [envelopeCost]
  );

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const data = await fetchCostData(getClientId() ?? 0, getCaseId() ?? 0);
        if (data) {
          setCostTotalSummary((prevState) => ({
            ...prevState,
            totalCreditCard: data.total_credit_card ?? 0,
            paid: data.paid ?? 0,
            openNotRequested: data.open_not_requested ?? 0,
            requested: data.requested ?? 0,
            totalAmount:
              parseFloat(data.total_amount || 0) + parseFloat(data.envelope_cost.amount || 0), // Only set the base totalAmount here
          }));
          setEnvelopeCost(data.envelope_cost ?? {});
          setCosts(data.costs ?? []);
          setRequestedCosts(data.requested_costs ?? []);
          setCreditCardCosts(data.credit_card_costs ?? []);
          setOpenCosts(data.open_costs ?? []);
          setPaidCosts(data.paid_costs ?? []);
          setSlotDetails(data.slot_details ?? {});
        }
      } catch (error) {
        console.error("Failed to fetch costs:", error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [triggerUpdate, toggleVar]);

  return (
    <div
      // style={{
      //   paddingTop: "131px",
      //   overflow: "scroll",
      //   scrollbarWidth: "none",
      // }}
      className="TreatmentPage-main-container invisible-scrollbar"
    >
      <CostManagementModal />
      <CostTabs
        pageObject={pageObject}
        openCosts={openCosts}
        requestedCosts={requestedCosts}
        costs={costs}
        creditCardCosts={creditCardCosts}
        paidCosts={paidCosts}
        slotDetails={slotDetails}
        envelopeCostState={[envelopeCost, setEnvelopeCost]}
        onUpdate={updateTotalAmount}
        loading={isLoading || !currentCase || !client}
        costTotalSummary={costTotalSummary}
      />
      <NotesSectionDashboard pageName={"Costs"} />
    </div>
  );
};

export default CostDashboard;
